import { useEffect, useState } from "react";
import Sidebar from "@/components/Sidebar";
import ResultsTable from "@/components/ResultsTable";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { ChevronRight, ArrowLeft, History as HistoryIcon } from "lucide-react";

export default function History() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [detailResults, setDetailResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/history");
        setItems(data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const openDetail = async (id) => {
    setSelected(id);
    setDetailResults([]);
    const { data } = await api.get(`/history/${id}`);
    setDetailResults(data.results || []);
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-[#F8F9FA]">
      <Sidebar />
      <main className="flex-1 p-6 sm:p-10">
        {!selected ? (
          <>
            <div className="mb-8">
              <div className="eyebrow mb-2">Registros</div>
              <h1 className="font-display text-3xl sm:text-4xl font-bold text-[#09090B]">
                Histórico de buscas
              </h1>
              <p className="text-sm text-zinc-500 mt-2">
                Últimas 50 buscas realizadas na sua conta.
              </p>
            </div>

            {loading ? (
              <div className="eyebrow">Carregando...</div>
            ) : items.length === 0 ? (
              <div className="border border-dashed border-zinc-200 rounded-md p-12 text-center bg-white">
                <HistoryIcon className="w-8 h-8 text-zinc-300 mx-auto mb-3" />
                <div className="eyebrow mb-2">Sem histórico</div>
                <p className="text-sm text-zinc-500">Faça sua primeira busca para começar.</p>
              </div>
            ) : (
              <div className="bg-white border border-zinc-200 rounded-md divide-y divide-zinc-100" data-testid="history-list">
                {items.map((it) => (
                  <button
                    key={it.id}
                    onClick={() => openDetail(it.id)}
                    className="w-full flex items-center justify-between px-5 py-4 hover:bg-zinc-50 transition-colors text-left"
                    data-testid={`history-item-${it.id}`}
                  >
                    <div>
                      <div className="text-sm font-medium text-zinc-900 font-mono">
                        {new Date(it.created_at).toLocaleString("pt-BR")}
                      </div>
                      <div className="text-xs text-zinc-500 mt-1">
                        {it.total} códigos · {it.found} com imagens
                      </div>
                    </div>
                    <ChevronRight className="w-4 h-4 text-zinc-400" />
                  </button>
                ))}
              </div>
            )}
          </>
        ) : (
          <>
            <Button
              variant="ghost"
              onClick={() => setSelected(null)}
              className="mb-6 -ml-3"
              data-testid="back-to-history-button"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Voltar
            </Button>
            <div className="mb-6">
              <div className="eyebrow mb-2">Detalhes</div>
              <h1 className="font-display text-2xl font-semibold text-[#09090B]">
                {detailResults.length} produtos
              </h1>
            </div>
            <ResultsTable results={detailResults} />
          </>
        )}
      </main>
    </div>
  );
}
